"use strict";

/**
 * Provide frontend errors collection API
 * 
 * ```js
 * FlixErrorLogger.log("some error message", "error_type");
 * ```
 * 
 * ```html
 * <video onerror="FlixErrorLogger.log(this.src, 'video_loading')" 
 * ```
 * @method FlixErrorLogger.log
 */
var FlixErrorLogger = function () {
  document.addEventListener('flix:load', onPageLoad);

  /**
   * Enable or disable error logging
   */
  var enabled = false; // disable for now

  var sent = false;
  var data = [];
  var pageStartTime;
  function getEndpoint() {
    return Flix.env == 'production' ? 'https://ac2.tnaflix.com/js_errors.php' : '/local/js-errors';
  }
  function onPageLoad() {
    pageStartTime = Math.floor(Date.now() / 1000);

    // Check if data is not empty and send it (plus reset data for SPA)
    send();
  }

  /**
   * @param {string} errorMessage 
   * @param {string} errorType 
   */
  function log(errorMessage) {
    var errorType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'other';
    return function (errorMessage, _errorMessage$toStrin, _errorMessage, _errorMessage$toStrin2, _errorMessage2) {
      if (!enabled) {
        return;
      }
      var errorMessage = (_errorMessage$toStrin = (_errorMessage = errorMessage) === null || _errorMessage === void 0 ? void 0 : _errorMessage.toString()) !== null && _errorMessage$toStrin !== void 0 ? _errorMessage$toStrin : '';
      if (isMessageShouldBeIgnored(errorMessage)) {
        document.dispatchEvent(new Event('flix:error_external'));
        return;
      }
      FlixStats.increment(errorType == 'promise_rejection' ? 'error_promise_rejection' : 'error_internal');
      data.push({
        type: errorType,
        utm_id: Flix.ads.iid,
        url: window.location.href,
        adblock: Flix.ads.adblock(),
        ts: Math.floor(Date.now() / 1000),
        message: (_errorMessage$toStrin2 = (_errorMessage2 = errorMessage) === null || _errorMessage2 === void 0 ? void 0 : _errorMessage2.toString()) !== null && _errorMessage$toStrin2 !== void 0 ? _errorMessage$toStrin2 : ''
      });
    }(errorMessage);
  }

  /**
   * Old send. should be replaced with the new one
   */
  function send() {
    if (!data.length || sent) {
      return;
    }
    sent = true;
    var pageEndTime = Math.floor(Date.now() / 1000);
    data.forEach(function (item) {
      item.page_start_time = pageStartTime;
      item.page_end_time = pageEndTime;
    });
    var fd = new FormData();
    fd.append('data', JSON.stringify(data));
    var old_endpoint = getEndpoint();
    if (typeof navigator.sendBeacon !== 'function' || !navigator.sendBeacon(old_endpoint, fd)) {
      // Fallback if beacon is not supported
      var xhr = new XMLHttpRequest();
      xhr.open("POST", old_endpoint, false);
      xhr.setRequestHeader('Content-type', 'application/json');
      xhr.send(JSON.stringify(data));
    }
    sent = false;
    data = [];
  }

  /**
   * Ignore network errors like https://www.chromestatus.com/feature/4664843055398912 
   * and other errors that we cannot fix. We interested only in the logic errors in the code
   * 
   * @param {string} errorMessage 
   * @returns {boolean}
   */
  function isMessageShouldBeIgnored(errorMessage) {
    return errorMessage.indexOf('NetworkError') !== -1 || errorMessage.indexOf('AbortError') !== -1 || errorMessage.indexOf('Request aborted') !== -1 || errorMessage.indexOf('NotAllowedError') !== -1;
  }
  if (enabled) {
    // Listen on JS errors
    window.onerror = function (msg, src, line, col, error) {
      var _msg$toString;
      // Cross domain errors do not provide any information like source, line, or even error description.
      // It will only log "Script error." message ¯\_(ツ)_/¯
      if (!src && !error && !line) {
        // FlixStats.increment('error_external');
        return;
      }
      var errorMessage = (_msg$toString = msg === null || msg === void 0 ? void 0 : msg.toString()) !== null && _msg$toString !== void 0 ? _msg$toString : '';
      log("Error - ".concat(errorMessage, "; Src - ").concat(src, "; Line/col - ").concat(line, "/").concat(col), 'js');
    };
    window.onunhandledrejection = function (event) {
      var _event$reason$toStrin, _event$reason;
      var errorMessage = (_event$reason$toStrin = (_event$reason = event.reason) === null || _event$reason === void 0 ? void 0 : _event$reason.toString()) !== null && _event$reason$toStrin !== void 0 ? _event$reason$toStrin : '';
      log('Unhandled rejection: ' + errorMessage, 'promise_rejection');
    };

    // !! SHOULD BE REMOVED IN THE NEW VERSION !!
    window.addEventListener('pagehide', send);
  }
  return {
    log: log
  };
}();